import React, { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import SmartColour from "../../utils/ColourHandler";

const Divider = ({ blok }) => {
  const { align, colour, height, theme } = blok;

  const theme_colour = SmartColour(theme);

  const container = useRef();
  const light = useRef();

  useGSAP(
    () => {
      var timeline = gsap.timeline({
        scrollTrigger: {
          trigger: light.current,
          scrub: 3,
          start: "top 100%",
          end: "bottom 0%",
          markers: false,
        },
      });
      timeline.from(light.current, {
        y: "400px",
      });
      timeline.to(light.current, {
        y: "-500px",
      });
    },
    { scope: container.current }
  );

  if (!blok) return null; // Escape hatch

  return (
    <div
      className={`${
        theme_colour?.background !== "default"
          ? `bg-${theme_colour?.background}`
          : null
      } ${
        height === "small"
          ? "h-12"
          : height === "medium"
          ? "h-24"
          : height === "large"
          ? "h-48"
          : null
      }`}
    >
      <div
        className={`brand-light-container brand-light-container-${
          align && align
        }`}
        ref={container}
      >
        <div
          className={`bg-${
            colour ? colour : "orange"
          } brand-light blur-[100px]`}
          ref={light}
        />
      </div>
    </div>
  );
};

export default Divider;
